// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"W_agUBTR","PORTRAIT":"y5Uo88FG","LANDSCAPE":"_4VtxDkid"};